<template>
    <div>
        <kiosk-ten-dlc-controls
            v-model="fetchParams"
            placeholder="Search campaign ID, brand ID or brand name"
            @apply="applyFilters"
            @reset="resetFilters"
        ></kiosk-ten-dlc-controls>

        <page-loading v-if="loading && !list.length"></page-loading>

        <empty-state v-else-if="!list.length && !isEqual(defaultFilters(), fetchParams)" @reset="resetFilters" />

        <empty-state v-else-if="!list.length"> No campaigns found. </empty-state>

        <div v-if="list.length">
            <kiosk-tcr-campaigns-table>
                <kiosk-tcr-campaign-row
                    v-for="campaign in list"
                    :key="campaign.campaign_id"
                    :modelValue="campaign"
                ></kiosk-tcr-campaign-row>
            </kiosk-tcr-campaigns-table>

            <div v-if="fetchParams.cursor" class="mt-8">
                <vx-button
                    @click="loadData()"
                    color="muted-dark"
                    size="xl"
                    class="grow-0"
                    data-test="load-more-btn"
                    :loading="loading"
                >
                    Load More
                    <font-awesome-icon widthAuto :icon="faSpinner"></font-awesome-icon>
                </vx-button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton } from '@voxie/frontend-components';
import EmptyState from '~/components/general/EmptyState.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import KioskTenDlcControls from '~/components/kiosk/kiosk-ten-dlc/KioskTenDlcControls.vue';
import KioskTcrCampaignRow from '~/components/kiosk/kiosk-ten-dlc/list/KioskTcrCampaignRow.vue';
import KioskTcrCampaignsTable from '~/components/kiosk/kiosk-ten-dlc/list/KioskTcrCampaignsTable.vue';
import { useCursorPagination } from '~/composables/useCursorPagination';
import { adminTenDlcClient } from '~/services';
import type { TcrCampaign, TcrListParams } from '~/services/adminTenDlcClient.types';
import { isEqual } from '~/utils/helpers';

const defaultFilters = (): TcrListParams => ({
    query: '',
    sort_field: 'campaign_id',
    sort_dir: 'asc',
    per_page: 25,
    cursor: null,
});

const { loading, list, fetchParams, fetchRecords } = useCursorPagination<TcrCampaign, TcrListParams>();

const loadData = () => {
    fetchRecords(adminTenDlcClient.getTcrCampaigns(fetchParams.value));
};

const applyFilters = () => {
    fetchParams.value = {
        ...fetchParams.value,
        cursor: null,
    };
    loadData();
};

const resetFilters = () => {
    fetchParams.value = defaultFilters();
    loadData();
};

resetFilters();
</script>
